export enum DynamicFormRequiredType {
  False,
  True,
  /**
   * Used by multipart fields, like the textual questionnaire, when part of the field is answered the whole field
   * becomes required.
   * @type {DynamicFormRequiredType.Partial}
   */
  Partial,
}
